import React from 'react'
import styled from 'styled-components'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import PaletteSheet from 'components/Luxkit/PaletteSheet'

const Root = styled(PaletteSheet)`
  width: 100%;
  background-color: ${(props) => props.theme.palette.neutral.default.eight};

  @media print {
    display: none;
  }
`

function InverseColourBanner({ children }: React.PropsWithChildren) {
  return <Root paletteType="inverse">
    <LayoutContainer>
      {children}
    </LayoutContainer>
  </Root>
}

export default InverseColourBanner
